module.exports = "./img/8ac4dfebefcb669a5bc71fd91d318246.jpg";